import React from "react"
import PropTypes from "prop-types"
import "./marketing.scss"
import "./vodafone-marketing.scss"
import Button from "../shared/button/text-button"

import couple from "images/splashScreens/vodafone-couple.png"
import hands from "images/splashScreens/vodafone-hands.png"
import wifi from "images/splashScreens/vodafone-wifi.png"
import plane from "images/splashScreens/vodafone-plane.png"
import heart from "images/splashScreens/vodafone-heart.png"

const MarketingVodafone = ({ handleButtonClick }) => (
  <div className="marketing-page marketing-page--vodafone-1">
    <div className="marketing-page--vodafone-1--banner">
      <img src={couple} alt="" />
      <h1>Why choose Vodafone?</h1>
    </div>
    <div className="marketing-page--extras vodafone-1">
      <div className="thumbnailContainer">
        <div>
          <img src={wifi} alt="" />
          <p className="bold">Ultra-smart Router and Vodafone Broadband App​</p>
          <p>
            ​ Manage your router from your mobile and control a range of handy
            features and see who’s connected to your network,
          </p>
        </div>
        <div>
          <img src={hands} alt="" />
          <p className="bold">
            Finally, broadband knows that bedtime means bedtime
          </p>
          <p>
            Family Time lets you control who can use broadband and when. Set up
            your own family network and control who uses what and when. ​
          </p>
        </div>
        <div>
          <img src={plane} alt="" />
          <p className="bold">Keep everyone safe online​</p>
          <p>
            Keep everyone safe online​ With our content controls tool you can
            protect your kids from inappropriate websites. Also you can stop
            access of viruses and other malware.
          </p>
        </div>{" "}
        <div>
          <img src={heart} alt="" />
          <p className="bold">Keep everyone safe online​</p>
          <p>
            Keep everyone safe online​ With our content controls tool you can
            protect your kids from inappropriate websites. Also you can stop
            access of viruses and other malware.
          </p>
        </div>
      </div>
      <div className="heading-container">
        <h1>
          Lightning-fast mobile, Gigafast broadband and the best Entertainment.
          There are many reasons to choose Vodafone and its award-winning
          customer service.
        </h1>
      </div>
    </div>
    <div className="marketing-button-container">
      <Button text="Continue" onClick={handleButtonClick} />
    </div>
  </div>
)

MarketingVodafone.propTypes = {
  handleButtonClick: PropTypes.func.isRequired
}

export default MarketingVodafone
